const ANIMATE_ICON_SLOT = 1,
	CHARACTER_SLOT = 2,
	GYATE_FOX_COIN_SKIN = 101,

	/*
INSERT INTO `perks`
	(`accid`, `perkid`, `num`, `choice`, `date`)
    SELECT ta.accid, 101, 0, 1, 1602691199 FROM `forum_accounts` AS ta
        WHERE ta.sub = 1 AND ta.accid NOT IN(
            SELECT tp.accid FROM `perks` as tp WHERE tp.date BETWEEN 1601179200 AND 1602691200
        )
*/

	perk = Object.freeze({
		ANIMATE_ICON_SLOT,
		CHARACTER_SLOT,
		GYATE_FOX_COIN_SKIN,

		CHOICES: [
			{
				startDate: 1594094400 * 1000,
				endDate: 1595347200 * 1000,
				choices: [
					{
						perk: ANIMATE_ICON_SLOT,
						count: 2
					},
					{
						perk: CHARACTER_SLOT,
						count: 5
					}
				]
			},
			{
			// startDate: 1601179200 * 1000, //2020/9/21
				startDate: 1601179200 * 1000,
				endDate: 1602691200 * 1000, // 2020/10/14
				choices: [
					{
						perk: ANIMATE_ICON_SLOT,
						count: 1
					},
					{
						perk: CHARACTER_SLOT,
						count: 5
					},
					{
						perk: GYATE_FOX_COIN_SKIN,
						count: null
					}
				]
			},
			{
				startDate: 1604203200 * 1000,
				endDate: 1605355200 * 1000,
				choices: [
					{
						perk: ANIMATE_ICON_SLOT,
						count: 1
					},
					{
						perk: CHARACTER_SLOT,
						count: 5
					}
				]
			}
		]
	})

module.exports = perk